<template>
    <section class="home-container">
        <MasterPage title="食材类别">
            <div slot="title-icon">
                <Icon type="ios-nutrition" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="类别名称：">
                            <Input v-model="name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="类别状态：">
                            <Select v-model="isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page transfer :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增食材类别" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="类别名称：">
                    <Input v-model="itemAdd.name" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改食材类别" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="类别名称：">
                    <Input v-model="itemAdd.name" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '类别名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:160,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'md-unlock',
                                        label:"small",
                                    },
                                    on: {
                                        click: () => {
                                            this.reuseItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '启用')
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                ]);
                            }
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                name:'',
                isDeleted:'false',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                itemAdd:{
                    id:'',
                    name:'',
                }
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('foodMaterialType/list',{
                    name:this.name,
                    isDeleted:this.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'食材类别查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入食材类别名称');
                }
                this.addLoading = true
                this.$http.post('foodMaterialType/add',{
                    name:this.itemAdd.name,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材类别新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食材类别新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(mutrition){
                this.itemAdd.id = mutrition.id
                this.itemAdd.name = mutrition.name
                this.updateModel = true
            },
            updateItem(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入食材类别名称');
                }
                this.updateLoading = true
                this.$http.post('foodMaterialType/update',{
                    id:this.itemAdd.id,
                    name:this.itemAdd.name,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材类别修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食材类别修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = false
                this.itemAdd.id = this.itemAdd.name = ''
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用食材类别“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('foodMaterialType/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材类别禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食材类别禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用食材类别“'+item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('foodMaterialType/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材类别启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食材类别启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


